<template>
  <div class="login-page">
    <div class="login-shell">
      <div class="brand-title-row">
        <img class="brand-logo" :src="logoUrl" alt="logo" />
        <h1 class="brand-name">自助证件照管理系统</h1>
      </div>
      <section class="login-card">
        <div class="card-head">
          <h2 class="card-title">登录</h2>
          <p class="card-hint">使用账号密码进入系统</p>
        </div>
        <div class="field-stack">
          <label class="field-label">账号</label>
          <el-input class="ds-input" v-model="account" placeholder="请输入账号" prefix-icon="el-icon-user" clearable></el-input>
          <label class="field-label">密码</label>
          <el-input class="ds-input" v-model="password" placeholder="请输入密码" prefix-icon="el-icon-lock" show-password @keyup.enter.native="login()"></el-input>
          <el-button class="login-btn" type="primary" @click="login()">登录</el-button>
        </div>
        <div class="login-meta">
          <el-checkbox v-model="rememberPassword" class="remember-check">记住密码</el-checkbox>
          <button type="button" class="link-btn" @click="ChangePassword()">修改密码</button>
        </div>
      </section>
      <footer class="login-footer">
        <div>深圳市智多杰 © 2026</div>
        <a class="beian-link" href="https://beian.miit.gov.cn/" target="_blank" rel="noopener noreferrer">粵ICP备09022955号-2</a>
      </footer>
    </div>

    <el-dialog class="pwd-dialog" title="修改密码" :visible.sync="dialogFormVisible" width="420px" :show-close="false" :close-on-click-modal="false" :close-on-press-escape="false">
      <el-form :model="form" label-width="130px">
        <el-form-item label="账号"><el-input v-model="form.account_" placeholder="账号(必填项)"></el-input></el-form-item>
        <el-form-item label="旧密码"><el-input v-model="form.password_" placeholder="旧密码(必填项)" show-password></el-input></el-form-item>
        <el-form-item label="新密码"><el-input v-model="form.newPassword_" placeholder="新密码(必填项)" show-password></el-input></el-form-item>
        <el-form-item label="再次确认新密码"><el-input v-model="form.newPassword2_" placeholder="再次确认新密码(必填项)" show-password></el-input></el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { post } from '../../../public/request/request.js'
import logoUrl from '../../assets/logo.png'

export default {
  data() {
    return {
      logoUrl,
      account: '',
      password: '',
      rememberPassword: false,
      form: {},
      dialogFormVisible: false
    }
  },
  mounted() {
    const rememberedAccount = localStorage.getItem('rememberedAccount')
    const rememberedPassword = localStorage.getItem('rememberedPassword')
    const rememberPasswordFlag = localStorage.getItem('rememberPassword')

    if (rememberPasswordFlag === 'true' && rememberedAccount && rememberedPassword) {
      this.account = rememberedAccount
      this.password = rememberedPassword
      this.rememberPassword = true
    }
  },
  methods: {
    login() {
      if (this.account == '' || this.password == '') {
        this.$message.error('账号和密码不能为空')
        return
      }

      this.$message({
        message: '正在登录...',
        center: true
      })
      const loading = this.openLoading()
      post('101', {
        account: this.account,
        password: this.password
      })
        .then(response => {
          if (response.data.result == 0) {
            sessionStorage.setItem('loginInfo', JSON.stringify(response.data.data.user))
            sessionStorage['_token'] = response.data.data.token
            sessionStorage['_login'] = 'true'

            if (response.data.data.allowChannel !== undefined) {
              sessionStorage.setItem('allowChannel', response.data.data.allowChannel ? 'true' : 'false')
            } else {
              sessionStorage.setItem('allowChannel', 'true')
            }

            if (this.rememberPassword) {
              localStorage.setItem('rememberedAccount', this.account)
              localStorage.setItem('rememberedPassword', this.password)
              localStorage.setItem('rememberPassword', 'true')
            } else {
              localStorage.removeItem('rememberedAccount')
              localStorage.removeItem('rememberedPassword')
              localStorage.removeItem('rememberPassword')
            }

            post(201, null)
              .then(menuResponse => {
                if (menuResponse.data.result == 0) {
                  this.$setAuthority(menuResponse.data.data)
                  this.$router.push({
                    path: this.$route.query.redirect || '/home'
                  })
                  loading.close()
                } else {
                  this.$message.error('查询数据失败.:' + menuResponse.data.message)
                  loading.close()
                }
              })
              .catch(error => {
                this.$message.error((error && error.userMessage) || '查询数据失败。')
                loading.close()
              })
          } else if (response.data.errorcode == 1028) {
            this.$alert(response.data.message, {
              title: '提示',
              showClose: false,
              callback: action => {
                this.form = {
                  account_: this.account,
                  password_: this.password,
                  newPassword_: '',
                  newPassword2_: ''
                }
                this.dialogFormVisible = true
              }
            })
            loading.close()
          } else {
            this.$message.error('登录失败：' + response.data.message)
            loading.close()
          }
        })
        .catch(error => {
          sessionStorage['_token'] = ''
          sessionStorage['_login'] = 'false'
          this.$message.error((error && error.userMessage) || '登录失败')
          console.error('There was an error!', error)
          loading.close()
        })
    },
    check() {
      if (this.password == '') {
        return false
      }
      var pattern = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.?;:_=+-]).{8,}$/
      return pattern.test(this.password)
    },
    openLoading() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.4)'
      })
      return loading
    },
    ChangePassword() {
      this.form = {
        account_: this.account,
        password_: '',
        newPassword_: '',
        newPassword2_: ''
      }
      this.dialogFormVisible = true
    },
    submitForm() {
      if (this.form.account_ != '' && this.form.password_ != '' && this.form.newPassword_ != '' && this.form.newPassword2_) {
        if (this.form.newPassword_ == this.form.newPassword2_) {
          if (this.form.password_ != this.form.newPassword_) {
            var pattern = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[!@#$%^&*,.?;:_=+-]).{8,}$/
            if (pattern.test(this.form.newPassword_)) {
              let params = {
                account: this.form.account_,
                password: this.form.password_,
                newPassword: this.form.newPassword_
              }

              const loading = this.openLoading()
              post(102, params)
                .then(response => {
                  if (response.data.result == 0) {
                    this.$message.success('修改密码成功')
                    loading.close()
                    this.dialogFormVisible = false
                  } else {
                    this.$message.error('操作失败.:' + response.data.message)
                    loading.close()
                  }
                })
                .catch(error => {
                  this.$message.error((error && error.userMessage) || '操作失败。')
                  loading.close()
                })
            } else {
              this.$message.error('密码至少包含英文字符、数字及特殊符号，长度不小于8位')
            }
          } else {
            this.$message.error('新密码不能和旧密码相同')
          }
        } else {
          this.$message.error('两次输入的新密码不一致')
        }
      } else {
        this.$message.error('必填项不能为空')
      }
    }
  }
}
</script>

<style>
.login-page {
  --bg: #F4F6F9;
  --surface: #FFFFFF;
  --surface-2: #F7F8FA;
  --border: rgba(15, 23, 42, 0.08);
  --text: #1A1D24;
  --text-muted: #6B7280;
  --accent: #014DB2;
  --accent-hover: #013D8F;
  --shadow: 0 16px 40px rgba(15, 23, 42, 0.08);
  position: relative;
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: linear-gradient(180deg, #F7F9FC 0%, #EEF2F7 100%);
  color: var(--text);
}

.login-page::before,
.login-page::after {
  content: '';
  position: absolute;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(1, 77, 178, 0.10) 0%, rgba(1, 77, 178, 0) 78%);
  filter: blur(48px);
  pointer-events: none;
}

.login-page::before { width: 520px; height: 520px; right: -160px; top: -180px; }
.login-page::after { width: 780px; height: 780px; left: -280px; top: 50%; transform: translateY(-50%); }

.login-shell {
  position: relative;
  z-index: 1;
  width: 100%;
  height: 100%;
  padding: 40px 28px 28px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
}

.brand-title-row { display: flex; align-items: center; gap: 14px; }
.brand-logo { height: 48px; width: auto; object-fit: contain; display: block; }
.brand-name { margin: 0; font-size: 28px; font-weight: 700; color: var(--text); }

.login-card {
  width: min(400px, 100%);
  padding: 28px 26px 24px;
  border-radius: 18px;
  background: var(--surface);
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
}

.card-title { margin: 0; font-size: 22px; color: var(--text); }
.card-hint { margin: 8px 0 0; font-size: 13px; color: var(--text-muted); }
.field-stack { display: flex; flex-direction: column; gap: 8px; margin-top: 18px; }
.field-label { margin-top: 6px; font-size: 13px; color: #4B5563; }
.ds-input { width: 100%; }
.ds-input .el-input__inner {
  height: 44px; line-height: 44px; border-radius: 10px;
  border: 1px solid var(--border);
  background: var(--surface-2); color: var(--text);
}
.ds-input .el-input__inner:focus {
  border-color: var(--accent);
  background: #fff;
}
.ds-input .el-input__inner::placeholder { color: #9CA3AF; }
.ds-input .el-input__prefix,
.ds-input .el-input__icon { color: #9CA3AF; }
.login-btn.el-button--primary {
  width: 100%; height: 44px; margin-top: 12px; border: none; border-radius: 10px;
  font-weight: 600; background: var(--accent); border-color: var(--accent); color: #fff;
}
.login-btn.el-button--primary:hover,
.login-btn.el-button--primary:focus {
  background: var(--accent-hover); border-color: var(--accent-hover); color: #fff;
}
.login-meta { display: flex; align-items: center; justify-content: space-between; margin-top: 16px; }
.remember-check .el-checkbox__label { color: var(--text-muted); }
.link-btn { border: none; background: transparent; color: var(--accent); cursor: pointer; font-size: 13px; }
.link-btn:hover { color: var(--accent-hover); }
.brand-desc { margin: 0; color: var(--text-muted); font-size: 14px; }
.login-footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  color: #9CA3AF;
  text-align: center;
}
.beian-link { color: #9CA3AF; text-decoration: none; }
.beian-link:hover { color: var(--accent); text-decoration: underline; }
.pwd-dialog .el-dialog { background: var(--surface); border-radius: 14px; }
.pwd-dialog .el-dialog__title, .pwd-dialog .el-form-item__label { color: var(--text); }
.pwd-dialog .el-input__inner {
  background: var(--surface-2);
  border-color: var(--border);
  color: var(--text);
}
.pwd-dialog .el-input__inner:focus { border-color: var(--accent); background: #fff; }
</style>
